'use strict';
import { addEvent } from './addEvent/addEvent';
import { mainPageBaner } from './mainPageBaner/mainPageBaner';

document.addEventListener('DOMContentLoaded', function () {
  window.mainPagebaner = new mainPageBaner(
    document.getElementsByClassName('main-page-baner__container')
      ? document.getElementsByClassName('main-page-baner__container')[0]
      : null
  );

  if (window.mainPagebaner) window.mainPagebaner.init();

  if (window.preloading) {
    setTimeout(() => {
      if (window.mainPagebaner) window.mainPagebaner.start();
    }, 1500);
  } else {
    window.mainPagebaner.start();
  }
});

addEvent(window, 'load', function () {
  goToFirstSection();
});

function goToFirstSection() {
  const toNextBtn = document.getElementsByClassName('scroll-to-first-section');
  if (toNextBtn.length == 0) return;

  let target = document.body.getElementsByClassName('main-page-section__container');
  if (target.length == 0) return;
  target = target[0];

  toNextBtn[0].addEventListener('click', event => {
    event.stopPropagation();
    event.stopPropagation();

    if (window.smoothScroll) {
      window.smoothScroll.scrollIntoView(target, {
        alignToTop: true,
        onlyScrollIfNeeded: false,
      });
    } else {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
    return false;
  });
}
